export default __webpack_public_path__ + "static/29-2ac1c7a104f564aa944427725a5288d1.jpg";